<template>
    <div>
        <!-- 公共头部组件 -->
        <header class="medical-header">
            <div class="header-container">
                <!-- 标题 -->
                <div class="header-title">
                    <i class="fa fa-heartbeat"></i> Anbio Shop
                </div>
                <!-- 导航链接 -->
                <div class="header-nav">
                    <router-link to="/" class="nav-link">All Products</router-link>
                </div>
            </div>
        </header>

        <div class="medical-header-lint"></div>
    </div>
</template>

<script>
export default {
    name: "MedicalHeader",
    // 可自定义属性（如需动态修改标题/链接）
    props: {
        title: {
            type: String,
            default: "Anbio Shop"
        },
        navText: {
            type: String,
            default: "All Products"
        },
        navTo: {
            type: String,
            default: "/products"
        }
    }
};
</script>

<style lang="less" scoped>
@import "https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css";

// 核心样式变量（和商品页统一）
@primary: #1677ff;
@border-color: #e5e5e5;
@max-width: 1400px;

.medical-header {
    width: 100%;
    background: #fff;
    border-bottom: 1px solid @border-color;
    text-align: left;
    height: 80px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 10;


    // 容器（和商品页1400px对齐）
    .header-container {
        width: @max-width;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 0 20px;
        box-sizing: border-box;

        // 标题样式（复刻图片）
        .header-title {
            font-size: 18px;
            font-weight: bold;
            color: @primary;
            display: flex;
            align-items: center;
            gap: 6px;


            i {
                font-size: 16px;
            }
        }

        // 导航链接
        .header-nav {
            .nav-link {
                color: @primary;
                text-decoration: none;
                font-size: 14px;
                padding-bottom: 2px;
                border-bottom: 2px solid @primary; // 下划线效果

                &:hover {
                    opacity: 0.8;
                }
            }
        }
    }
}

.medical-header-lint {
    width: 100%;
    height: 80px;
}
</style>
